import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Injector, Input, OnInit } from '@angular/core';
import { DevicesClass } from '@app/core/classes';
import { RoutingConfig } from '@app/routing/routing.config';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DialogComponentModel } from '@app/core/models/diallog';
import { IPartnerPublicProduct } from '@app/modules/partner-modules/partner.model';
import { AppStaticURL } from '@app/app.settings';
import { Gallery, GalleryItem, ImageItem, ThumbnailsPosition, ImageSize } from 'ng-gallery';
import { Lightbox } from 'ng-gallery/lightbox';

@UntilDestroy()
@Component({
  selector: 'app-partner-crud-product',
  templateUrl: 'detail-product.component.html',
  styleUrls: [`./detail-product.component.scss`],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class DetailProductComponent extends DevicesClass implements OnInit {
  public StaticURL = AppStaticURL;
  public Routing = RoutingConfig;

  /**
   * Base component variables.
   */
  public Product: IPartnerPublicProduct;
  public Photos: GalleryItem[];

  @Input() Data: any;

  constructor(injector: Injector,
    public cdr: ChangeDetectorRef,
    public ref: DynamicDialogRef,
    public gallery: Gallery,
    public lightbox: Lightbox,
    private router: Router,
    private dialogConfig: DynamicDialogConfig,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    /**
     * Set of base popup settings.
     */
    this.onProductInputConfig();

    /**
     * Map of product photo data.
     */
    this.Photos = this.Product.photos.map(item => new ImageItem({
      src: this.StaticURL + item.path,
      thumb: this.StaticURL + item.thumbnailPath
    }));
  }

  onProductInputConfig(): void {
    const InputConfig = this.dialogConfig.data as DialogComponentModel || null;
    this.Product = InputConfig.includeData as any || null;
  }

  onMinimumHoursValue(hours: number): string {
    if (!hours || hours === 0) {
      return '';
    }
    if (hours === 1) {
      return `/ ${hours} час`;
    }
    if (hours === 2 || hours === 3 || hours === 4) {
      return `/ ${hours} часа`;
    }
    if (hours >= 5) {
      return `/ ${hours} часов`;
    }
  }

  onCloseDialog(): void {
    this.ref.close()
  }

  get onProductMainPhoto(): string {
    return this.Product.photos.length ? this.Product.photos[0].path : null;
  }
}
